import { Route, Routes } from "react-router-dom";

import { ExternalTaskPage } from "pages/external";

import { OrganizationProvider } from "context/OrganisationContext";

import { ThemeWrapper } from "theme/theme-wrapper";

export const InitializeExternalApp = () => {
	return (
		<OrganizationProvider>
			<ThemeWrapper>
				<App />
			</ThemeWrapper>
		</OrganizationProvider>
	);
};

const App = () => {
	return (
		<Routes>
			<Route path="user-tasks/:slug/:base64Email" element={<ExternalTaskPage />} />
		</Routes>
	);
};
